import { render } from "./ModeratorRequestTableHeader.vue?vue&type=template&id=726c6a93&scoped=true"
const script = {}

import "./ModeratorRequestTableHeader.vue?vue&type=style&index=0&id=726c6a93&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-726c6a93"]])

export default __exports__